// Phase 9 — active profile store. Mirrors tokenStore. Singleton synchronous
// access used by the axios interceptor + ProfileContext.

const ACTIVE_PROFILE_KEY = "vw_active_profile_id";

export const profileStore = {
  get: () => {
    try { return localStorage.getItem(ACTIVE_PROFILE_KEY); } catch (_e) { return null; }
  },
  set: (id) => {
    try { if (id) localStorage.setItem(ACTIVE_PROFILE_KEY, id); else localStorage.removeItem(ACTIVE_PROFILE_KEY); } catch (_e) { /* noop */ }
  },
  clear: () => {
    try { localStorage.removeItem(ACTIVE_PROFILE_KEY); } catch (_e) { /* noop */ }
  },
};

// Avatar gradient + label config — single source of truth used by the picker
// grid, the manage-profiles page, and the header dropdown.
export const AVATAR_OPTIONS = [
  { key: "violet", label: "Aurora", gradient: "from-violet-500 to-fuchsia-700", isKidVariant: false },
  { key: "crimson", label: "Crimson", gradient: "from-rose-500 to-red-700", isKidVariant: false },
  { key: "emerald", label: "Forest", gradient: "from-emerald-500 to-green-700", isKidVariant: false },
  { key: "amber", label: "Amber", gradient: "from-amber-400 to-orange-600", isKidVariant: false },
  { key: "sky", label: "Pacific", gradient: "from-sky-400 to-cyan-700", isKidVariant: false },
  { key: "rose", label: "Rose", gradient: "from-rose-400 to-pink-700", isKidVariant: false },
  { key: "slate", label: "Slate", gradient: "from-slate-400 to-gray-700", isKidVariant: false },
  { key: "kid_panda", label: "Panda", gradient: "from-yellow-300 to-emerald-400", isKidVariant: true, icon: "panda" },
  { key: "kid_robot", label: "Robot", gradient: "from-violet-300 to-cyan-400", isKidVariant: true, icon: "robot" },
  { key: "kid_unicorn", label: "Unicorn", gradient: "from-pink-300 to-purple-400", isKidVariant: true, icon: "unicorn" },
];

export function avatarOptionFor(avatarKey) {
  return AVATAR_OPTIONS.find((a) => a.key === avatarKey) || AVATAR_OPTIONS[0];
}
